import { apiGet } from "../../../utils/apiRequests";
import {
  GET_DASHBOARD_ANNOUNCEMENT_LOADING,
  GET_DASHBOARD_ANNOUNCEMENT_SUCCESS,
  GET_DASHBOARD_ANNOUNCEMENT_ERROR,
  GET_DASHBOARD_SPONSORS_LOADING,
  GET_DASHBOARD_SPONSORS_SUCCESS,
  GET_DASHBOARD_SPONSORS_ERROR,
  GET_DASHBOARD_NEWS_LOADING,
  GET_DASHBOARD_NEWS_SUCCESS,
  GET_DASHBOARD_NEWS_ERROR,
  GET_DASHBOARD_EVENTS_LOADING,
  GET_DASHBOARD_EVENTS_SUCCESS,
  GET_DASHBOARD_EVENTS_ERROR,
  GET_DASHBOARD_LATEST_TOURNMENT_LOADING,
  GET_DASHBOARD_LATEST_TOURNMENT_SUCCESS,
  GET_DASHBOARD_LATEST_TOURNMENT_ERROR,
  GET_DASHBOARD_COMBINE_LEADERBOARD_LOADING,
  GET_DASHBOARD_COMBINE_LEADERBOARD_SUCCESS,
  GET_DASHBOARD_COMBINE_LEADERBOARD_FAIL,
} from "../../../constant/actionTypes";

export const getDashboardAnnouncements = () => (dispatch) => {
  dispatch({ type: GET_DASHBOARD_ANNOUNCEMENT_LOADING });
  apiGet(
    "/api/announcement/latest",

    (response) => {
      // console.log("get announcements on dashboard response ==============> ", response)
      if (response.error == true) {
        dispatch({
          type: GET_DASHBOARD_ANNOUNCEMENT_ERROR,
          response: response.message,
        });
      } else {
        dispatch({
          type: GET_DASHBOARD_ANNOUNCEMENT_SUCCESS,
          response: response,
        });
      }
    },
    (error) => {
      // console.log('error ===>>>>', error)
      dispatch({ type: GET_DASHBOARD_ANNOUNCEMENT_ERROR, response: error });
    }
  );
};

export const getDashboardSponsors = () => (dispatch) => {
  dispatch({ type: GET_DASHBOARD_SPONSORS_LOADING });
  apiGet(
    "/api/sponsor/enabled",
    (response) => {
      // console.log("get dashboard sponsors response ==============> ", response);
      if (response.error == true) {
        dispatch({
          type: GET_DASHBOARD_SPONSORS_ERROR,
          response: response.message,
        });
      } else {
        dispatch({ type: GET_DASHBOARD_SPONSORS_SUCCESS, response: response });
      }
    },
    (error) => {
      // console.log("error ===>>>>", error);
      dispatch({ type: GET_DASHBOARD_SPONSORS_ERROR, response: error });
    }
  );
};

export const getDashboardNews = () => (dispatch) => {
  dispatch({ type: GET_DASHBOARD_NEWS_LOADING });
  apiGet(
    "/api/news/latest",
    (response) => {
      // console.log("get dashboard news response ==============> ", response);
      if (response.error == true) {
        dispatch({
          type: GET_DASHBOARD_NEWS_ERROR,
          response: response.message,
        });
      } else {
        dispatch({ type: GET_DASHBOARD_NEWS_SUCCESS, response: response });
      }
    },
    (error) => {
      // console.log("error ===>>>>", error);
      dispatch({ type: GET_DASHBOARD_NEWS_ERROR, response: error });
    }
  );
};

export const getDashboardCalender = () => (dispatch) => {
  dispatch({ type: GET_DASHBOARD_EVENTS_LOADING });
  apiGet(
    "/api/events/",
    (response) => {
      if (response.error == true) {
        dispatch({
          type: GET_DASHBOARD_EVENTS_ERROR,
          response: response.message,
        });
      } else {
        dispatch({
          type: GET_DASHBOARD_EVENTS_SUCCESS,
          response: response.data,
        });
      }
    },
    (error) => {
      dispatch({ type: GET_DASHBOARD_EVENTS_ERROR, response: error });
    }
  );
};

export const getLatestTournamentLeaderboard = () => (dispatch) => {
  dispatch({
    type: GET_DASHBOARD_LATEST_TOURNMENT_LOADING,
  });

  apiGet("/api/tournament/POTY/getLatestTournamentLeaderboad", (response) => {
    if (response.error == true) {
      dispatch({
        type: GET_DASHBOARD_LATEST_TOURNMENT_ERROR,
        response: response.message,
      });
    } else {
      dispatch({
        type: GET_DASHBOARD_LATEST_TOURNMENT_SUCCESS,
        response: response,
      });
    }
  });
};

export const getLatestCombinedLeaderboard = () => (dispatch) => {
  dispatch({
    type: GET_DASHBOARD_COMBINE_LEADERBOARD_LOADING,
  });

  apiGet("/api/tournament/POTY/getLatestCombinedLeaderboard", (response) => {
    if (response.error == true) {
      dispatch({
        type: GET_DASHBOARD_COMBINE_LEADERBOARD_FAIL,
        response: response.message,
      });
    } else {
      dispatch({
        type: GET_DASHBOARD_COMBINE_LEADERBOARD_SUCCESS,
        response: response,
      });
    }
  });
};

// /api/tournament/POTY/getLatestCombinedLeaderboard
